import { Grid, Typography } from "@mui/material";
import { utils } from "../../../utils/utils";

const Info = ({ description, highlight, color, ingress, egress, total, real, lastClosureAmount, diff, price, isTitles, actions }) => {
    const GetValue = value =>
        isTitles ? value : utils.formatMoney(value);

    const totalDisplay = GetValue(total);

    const diffDisplau = !isTitles
        ? GetValue(real - total)
        : GetValue(diff);

    return (
        <Grid container spacing={1}>
            <Grid style={{ textTransform: 'uppercase' }} size={2}>
                <Typography color='primary' variant={highlight ? 'h6' : 'subtitle1'} component='p'>
                    <strong>{description}</strong>
                </Typography>
            </Grid>
            <Grid size="grow">
                <Grid container spacing={2} justifyContent="flex-end">
                    {
                        (price || price === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong>{GetValue(price)}</strong> : GetValue(price)}
                            </Typography>
                        </Grid>
                    }
                    {
                        (lastClosureAmount || lastClosureAmount === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong>{GetValue(lastClosureAmount)}</strong> : GetValue(lastClosureAmount)}
                            </Typography>
                        </Grid>
                    }
                    {
                        (ingress || ingress === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong>{GetValue(ingress)}</strong> : GetValue(ingress)}
                            </Typography>
                        </Grid>
                    }
                    {
                        (egress || egress === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong>{GetValue(egress)}</strong> : GetValue(egress)}
                            </Typography>
                        </Grid>
                    }
                    {
                        (total || total === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong> {totalDisplay} </strong> : totalDisplay}
                            </Typography>
                        </Grid>
                    }
                    {
                        (diff || diff === 0) &&
                        <Grid size="grow">
                            <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                                {highlight ? <strong> {diffDisplau} </strong> : diffDisplau}
                            </Typography>
                        </Grid>
                    }
                    <Grid size={2}>
                        <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                            {highlight ? <strong>{GetValue(real)}</strong> : GetValue(real)}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            {
                actions &&
                <Grid size={1}>
                    {isTitles &&
                        <Typography color={color ? 'primary' : ''} variant='subtitle1' component='p' align="right">
                            {highlight ? <strong>Acciones</strong> : 'Acciones'}
                        </Typography>
                    }
                </Grid>
            }
        </Grid>
    );
}

export default Info;